import config from 'config';
import { Connection, createConnection } from 'mongoose';

export class MongoConnection {
  private static connection?: Connection;

  constructor() {
    void MongoConnection.initialize();
  }

  public static get Instance(): Promise<Connection> {
    return this.initialize();
  }

  private static async initialize(): Promise<Connection> {
    if (this.connection) return this.connection;
    this.connection = await createConnection(
      config.get('mongodb.uri'),
      config.has('mongodb.options') ? { ...config.get('mongodb.options') } : undefined
    ).asPromise();
    return this.connection;
  }
}
